<template>
  <div>
    <div class="navbar">
      <van-nav-bar :title="title" left-text="返回" right-text="按钮" left-arrow fixed @click-left="onClickLeft"
        @click-right="onClickRight">
        <template #right>
          <van-icon name="ellipsis" color="#B7BBBF" style="font-weight: 600;font-size: 18px;" />
        </template>
      </van-nav-bar>
    </div>
    <van-overlay :show="showModal" @click="showModal = false" z-index="900" :lock-scroll="true" class-name="overlay">
      <div class="drawer-menu">
        <div class="menu-item" @click="goHome">
          <van-icon name="wap-home-o" /><span>回到首页</span></div>
        <div class="menu-item" @click="goLogin">
          <van-icon name="user-o" /><span>立即登录</span></div>
        <div class="menu-item" @click="goExit">
          <van-icon name="close " /><span>安全退出</span></div>
      </div>
    </van-overlay>
    <!-- <div class="modal" v-if="showModal">
    </div> -->
  </div>
</template>

<style lang="less" scoped>
  .navbar {
    background: #fff;
    height: 46px;
    display: flex;
    z-index: 999;
  }

  .overlay {
    top: 46px;

    .drawer-menu {
      position: absolute;
      right: 0;
      top: 0;
      min-height: 140px;
      padding: 10px 20px;
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(28, 31, 33, 0.10), 0 4px 8px 0 rgba(28, 31, 33, 0.10), 0 8px 16px 0 rgba(28, 31, 33, 0.10), 0 12px 24px 0 rgba(28, 31, 33, 0.10), 0 16px 32px 0 rgba(28, 31, 33, 0.10);
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      z-index: 998;

      .menu-item {
        line-height: 45px;
        height: 45px;
        cursor: pointer;

        .van-icon {
          line-height: 45px;
          margin-right: 8px;
        }

        span {
          display: inline-block;
          line-height: 45px;
        }
      }
    }
  }

  .modal {
    width: 100%;
    min-height: calc(100vh - 60px);
    height: 100%;
    position: absolute;
    top: 46px;
    left: 0;
    background: rgba(43, 51, 59, 0.60);
    z-index: 900;
  }
</style>

<script>
  import Vue from "vue";
  import * as auth from "@/libs/auth"
  import {
    NavBar
  } from "vant";

  Vue.use(NavBar);
  import {
    Overlay
  } from 'vant';

  Vue.use(Overlay);
  export default {
    data() {
      return {
        showModal: false,
      }
    },
    props: {
      title: {
        type: String,
        default: '标题'
      }
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1);
      },
      onClickRight() {
        this.showModal = !this.showModal;
      },
      goHome() {
        this.$router.push("/");
      },
      goLogin() {
        this.$router.push("/login");
      },
      goExit() {
        auth.removeUser();
        this.$router.push("/");
      }
    },
  }
</script>